pez.module('header', function($, $el) {
    var $win = $(window);
    var $header = $('header');
    var scrolled = null;
    var threshold = 20;

    function handleScroll() {
        $header.addClass('-scrolled');
        scrolled = true;
    }

    function handleUnscroll() {
        $header.removeClass('-scrolled');
        scrolled = false;
    }

    function $winScroll() {
        var y = $win.scrollTop();
        var c = y > threshold;
        if(c && scrolled !== true) {
            handleScroll();
        } else if (!c && scrolled !== false ) {
            handleUnscroll();
        }
    }

    function gotoHash(hash) {
        handleScroll();
        setTimeout(function() {
            var y = $(window.location.hash).offset().top;
            $('html,body').animate({ scrollTop: y - $el.outerHeight() });
        }, 50);
    }

    function adjustForHash() {
        if(window.location.hash) {
            gotoHash(window.location.hash);
        }
        $('a[data-subpage]').click(function() {
            gotoHash($(this).data().subpage);
        });
    }

    adjustForHash();

    $win.scroll($winScroll);
});